export default "__VITE_ASSET__B4Qzp7D0__"